import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { PagesPartialsModule } from 'src/app/components/pages-partials/pages-partials.module';
import { HttpTranslateFactory } from 'src/app/helpers';
import {
  NgbCollapseModule,
  NgbDropdownModule,
  NgbDatepickerModule,
  NgbDateNativeUTCAdapter,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomPipesModule } from 'src/app/pipes/custom-pipes.module';
import { ApiService } from 'src/app/services/api.service';
import { InfoFormModalService } from 'src/app/services/info-form-modal.service';
import { RouterService } from 'src/app/services/router.service';
import { HeaderComponent } from './header/header.component';
import { InfoFormModalComponent } from './info-form-modal/info-form-modal.component';
import { InfoFormComponent } from './info-form/info-form.component';
import { MultipleInputsComponent } from './multiple-inputs/multiple-inputs.component';
import { LangSwitcherComponent } from './navbar/components/lang-switcher/lang-switcher.component';
import { NavbarDropComponent } from './navbar/components/navbar-drop/navbar-drop.component';
import { NavbarNoauthComponent } from './navbar/navbar-noauth/navbar-noauth/navbar-noauth.component';
import { NavbarComponent } from './navbar/navbar.component';
import { WorkOrderComponent } from './workorders-tab/workorders-tab.component';
import { DynamicFormComponent } from './edit-form/dynamic-form.component';
import { DynamicFormContainer } from './edit-form/dynamic-form.container';
import { SelectObservablePipe } from './edit-form/pipes/select-observable.pipe';
import { TemplateTextListComponent } from './template-text-list/template-text-list.component';
import { TemplateTextListContainer } from './template-text-list/template-text-list.container';
import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { BookmarksTabComponent } from './bookmarks/bookmarks-tab/bookmarks-tab.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { BookmarkBtnComponent } from './bookmarks/bookmark-btn/bookmark-btn.component';
import { BookmarksLabelDialogComponent } from './bookmarks/bookmarks-label-dialog/bookmarks-label-dialog.component';
import { ActionFormModule } from "./action-form/action-form.module";
import { CommandProgressInfoComponent } from './command-progress/command-progress-info/command-progress-info.component';
import { ComandProgressDialogContainerComponent } from './command-progress/comand-progress-dialog-container/comand-progress-dialog-container.component';
import { ComandProgressDialogBaseComponent } from './command-progress/comand-progress-dialog-base.component';
import { FileUploaderFormComponent } from './file-uploader-form/file-uploader-form.component';
import { MessageResultComponent } from './message-result/message-result.component';
import { NotificationBellComponent } from './notification-bell/notification-bell.component';

@NgModule({
  imports: [
    CommonModule,
    ActionFormModule,
    NgbDropdownModule,
    RouterModule,
    NgbCollapseModule,
    ReactiveFormsModule,
    PagesPartialsModule,
    MatChipsModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatDialogModule,
    DragDropModule,
    CustomPipesModule,
    NgbDatepickerModule,
   
    TranslateModule.forChild({
      loader: {
        deps: [HttpClient],
        provide: TranslateLoader,
        useFactory: HttpTranslateFactory,
      },
    }),
  ],
  declarations: [
    NavbarComponent,
    HeaderComponent,
    WorkOrderComponent,
    NavbarDropComponent,
    NavbarNoauthComponent,
    InfoFormComponent,
    LangSwitcherComponent,
    InfoFormModalComponent,
    MultipleInputsComponent,
    DynamicFormComponent,
    DynamicFormContainer,
    SelectObservablePipe,
    TemplateTextListComponent,
    TemplateTextListContainer,
    DropdownMenuComponent,
    FileUploaderComponent,
    BookmarksTabComponent,
    PdfViewerComponent,
    BookmarkBtnComponent,
    BookmarksLabelDialogComponent,
    CommandProgressInfoComponent,
    ComandProgressDialogContainerComponent,
    ComandProgressDialogBaseComponent,
    FileUploaderFormComponent,
    MessageResultComponent,
    NotificationBellComponent,
  ],
  exports: [
    NavbarComponent,
    HeaderComponent,
    WorkOrderComponent,
    InfoFormComponent,
    NavbarNoauthComponent,
    InfoFormModalComponent,
    MultipleInputsComponent,
    DynamicFormComponent,
    DynamicFormContainer,
    TemplateTextListContainer,
    DropdownMenuComponent,
    FileUploaderComponent,
    PdfViewerComponent,
    CommandProgressInfoComponent,
    ComandProgressDialogContainerComponent,
    ComandProgressDialogBaseComponent,
    MessageResultComponent,
  ],
  providers: [
    ApiService,
    RouterService,
    InfoFormModalService,
    NgbDateNativeUTCAdapter,
  ],
})
export class ComponentsModule {}
